import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

//

// Views
const Dashboard = () => import('@/views/Dashboard')

// Profile
const Profile = () => import('@/views/profile/Profile')

// Data Master
const InformasiUmum = () => import('@/views/data-master/InformasiUmum')
const Artikel = () => import('@/views/data-master/Artikel/Artikel')
const ArtikelTambah = () => import('@/views/data-master/Artikel/ArtikelTambah')
const ArtikelEdit = () => import('@/views/data-master/Artikel/ArtikelEdit')
const Demo = () => import('@/views/data-master/Demo')
const Email = () => import('@/views/data-master/Email')
const Divisi = () => import('@/views/data-master/Divisi')
const Tingkatan = () => import('@/views/data-master/Level')
const DataTestCenter = () => import('@/views/data-master/DataTestCenter')
const Periode = () => import('@/views/data-master/Periode')
const PeriodeRpl= () => import('@/views/data-master/PeriodeRpl')
const PeriodeIuran = () => import('@/views/data-master/PeriodeIuran')

const DataTestCenterTambah = () => import('@/views/data-master/DataTestCenterTambah')
const DataTestCenterEdit = () => import('@/views/data-master/DataTestCenterEdit')
const JadwalTc = () => import('@/views/data-master/JadwalTc')
const Cabang = () => import('@/views/data-master/Cabang')
const Kupon = () => import('@/views/data-master/Kupon')
const Dokumen = () => import('@/views/data-master/Dokumen')
const PaktaIntegritas = () => import('@/views/data-master/PaktaIntegritas')
const MataKuliah = () => import('@/views/data-master/MataKuliah')

const DokumenAnggotaUmum = () => import('@/views/data-master/DokumenAnggotaUmum')
const DokumenAseanCpa = () => import('@/views/data-master/DokumenAseanCpa')
const DokumenPendukung = () => import('@/views/data-master/DokumenPendukung')
const DokumenRekomendasi = () => import('@/views/data-master/DokumenRekomendasi')

const MasterLokasi = () => import('@/views/data-master/MasterLokasi')
const MasterLokasiKota = () => import('@/views/data-master/MasterLokasiKota')
const MasterLokasiKecamatan = () => import('@/views/data-master/MasterLokasiKecamatan')

const Karir = () => import('@/views/data-master/Karir');

// User Manajemen
const PetugasIapi = () => import('@/views/user-manajemen/PetugasIapi')
const PetugasIapiAktif = () => import('@/views/user-manajemen/PetugasBO/PetugasBOAktif')
const PetugasIapiTidakAktif = () => import('@/views/user-manajemen/PetugasBO/PetugasBOTidakAktif')
const PetugasIapiTambah = () => import('@/views/user-manajemen/PetugasBO/PetugasIapiTambah')
const PetugasIapiEdit = () => import('@/views/user-manajemen/PetugasBO/PetugasIapiEdit')
const PetugasLMSAktif = () => import('@/views/user-manajemen/PetugasLMS/PetugasLMSAktif')
const PetugasLMSTidakAktif = () => import('@/views/user-manajemen/PetugasLMS/PetugasLMSTidakAktif')
const PetugasLMSTambah = () => import('@/views/user-manajemen/PetugasLMS/PetugasLMSTambah')
const PetugasLMSEdit = () => import('@/views/user-manajemen/PetugasLMS/PetugasLMSEdit')
const PetugasGrader = () => import('@/views/user-manajemen/PetugasGrader')
const PetugasBankSoalAktif = () => import('@/views/user-manajemen/PetugasBankSoalAktif')
const PetugasBankSoalTidakAktif = () => import('@/views/user-manajemen/PetugasBankSoalTidakAktif')
const PetugasGraderTambah = () => import('@/views/user-manajemen/PetugasGraderTambah')
const PetugasGraderEdit = () => import('@/views/user-manajemen/PetugasGraderEdit')
const PetugasTc = () => import('@/views/user-manajemen/PetugasTC/PetugasTc')
const PetugasTcAktif = () => import('@/views/user-manajemen/PetugasTC/PetugasTcAktif')
const PetugasTcTidakAktif = () => import('@/views/user-manajemen/PetugasTC/PetugasTcTidakAktif')
const PetugasTcTambah = () => import('@/views/user-manajemen/PetugasTC/PetugasTcTambah')
const PetugasTcEdit = () => import('@/views/user-manajemen/PetugasTC/PetugasTcEdit')
const UserGrader = () => import('@/views/user-manajemen/UserGrader/UserGrader')
const UserGraderAktif = () => import('@/views/user-manajemen/UserGrader/UserGraderAktif')
const UserGraderTidakAktif = () => import('@/views/user-manajemen/UserGrader/UserGraderTidakAktif')
const UserGraderTambah = () => import('@/views/user-manajemen/UserGrader/UserGraderTambah')
const UserGraderEdit = () => import('@/views/user-manajemen/UserGrader/UserGraderEdit')



// Sertifikasi

//sertifikasi 
const MasterSertifikasiNew = () => import('@/views/sertifikasiNew/MasterSertifikasi/MasterSertifikasi')
const MasterSertifikasiNewTambah = () => import('@/views/sertifikasiNew/MasterSertifikasi/MasterSertifikasiTambah')
const MasterSertifikasiNewEdit = () => import('@/views/sertifikasiNew/MasterSertifikasi/MasterSertifikasiEdit')
const MasterSertifikasiRPLNewTambah = () => import('@/views/sertifikasiNew/MasterSertifikasi/MasterSertifikasiRPLTambah')
const MasterSertifikasiRPLNewEdit = () => import('@/views/sertifikasiNew/MasterSertifikasi/MasterSertifikasiRPLEdit')
const DataPesertaSertifikasiNew = () => import('@/views/sertifikasiNew/MasterSertifikasi/DataPesertaSertifikasiNew')
const DataPesertaSertifikasiRPL = () => import('@/views/sertifikasiNew/MasterSertifikasi/DataPesertaSertifikasiRPL')
const DataPesertaSertifikasiDokumenNew = () => import('@/views/sertifikasiNew/MasterSertifikasi/DataPesertaDokumenNew')
const DataPesertaSertifikasiDetailNew = () => import('@/views/sertifikasiNew/MasterSertifikasi/DataPesertaSertifikasiDetailNew');
const DataPesertaLevel = () => import('@/views/sertifikasiNew/MasterSertifikasi/DataPesertaLevel')
/** Data Peserta */
const ChildDataPesertaSertifikasiRpl = () => import('@/views/sertifikasi/DataPeserta/DataPesertaRpl/DataPesertaRpl')
const DataPesertaSertifikasiDokumenRpl = () => import('@/views/sertifikasi/DataPeserta/DataPesertaRpl/DataPesertaDokumen')
const DetailDataPesertaSertifikasiDokumenRpl = () => import('@/views/sertifikasi/DataPeserta/DataPesertaRpl/DetailDataPeserta')
/** End Data Peserta */

const DataPeserta = () => import('@/views/sertifikasi/DataPeserta/DataPesertaSertifikasi/DataPesertaSertifikasi')

const listWaiver = () => import('@/views/rpl/Waiver/ListWaiver')
const DataWaiverRpl = () => import('@/views/rpl/Waiver/PenerimaWaiver')


const MasterWaiver = () => import('@/views/sertifikasi/Weiver/MasterWaiver')
const DataWeiver = () => import('@/views/sertifikasi/Weiver/Weiver')

const RiwayatPeserta = () => import('@/views/sertifikasi/RiwayatPeserta/RiwayatPesertaSertifikasi')
const DetailRiwayatPesertaSertifikasi = () => import('@/views/sertifikasi/RiwayatPeserta/detail/DetailRiwayatPesertaSertifikasi')

const PengajuanSertifikatRpl = () => import('@/views/rpl/PengajuanSertifikat/PengajuanSertifikat')
const DokumenPengajuanSertifikatRpl = () => import('@/views/rpl/PengajuanSertifikat/DataDokumen')


const WeiverDokumen = () => import('@/views/sertifikasi/Weiver/WeiverDokumen')
const PengajuanSertifikat = () => import('@/views/sertifikasi/PengajuanSertifikat/PengajuanSertifikat')
const DokumenPengajuanSertifikat = () => import('@/views/sertifikasi/PengajuanSertifikat/DataDokumen')
const DataPesertaCalonAnggota = () => import('@/views/sertifikasi/DataPeserta/DataPesertaCalon')
const DataPesertaSertifikasi = () => import('@/views/sertifikasi/DataPeserta/DataPesertaSertifikasi')
const DataPesertaSertifikasiRpl = () => import('@/views/sertifikasi/DataPeserta/DataPesertaRpl')
const DataPesertaSertifikasiDatadiri = () => import('@/views/sertifikasi/DataPeserta/DataDiri')
const DataPesertaSertifikasiDatakeanggotaan = () => import('@/views/sertifikasi/DataPeserta/DataKeanggotaan')
const DataPesertaSertifikasiDokumen = () => import('@/views/sertifikasi/DataPeserta/DataPesertaDokumen')
const JadwalTcTambah = () => import('@/views/sertifikasi/JadwalTc/JadwalTcTambah')
const JadwalTcSesiSatu = () => import('@/views/sertifikasi/JadwalTc/JadwalTcSesiSatu')
const JadwalTcSesiDua = () => import('@/views/sertifikasi/JadwalTc/JadwalTcSesiDua')
const JadwalTcSesiTiga = () => import('@/views/sertifikasi/JadwalTc/JadwalTcSesiTiga')
const JadwalTcRplSesiSatu = () => import('@/views/sertifikasi/JadwalTc/JadwalTcRplSesiSatu')
const JadwalTcRplSesiDua = () => import('@/views/sertifikasi/JadwalTc/JadwalTcRplSesiDua')
const JadwalTcRplSesiTiga = () => import('@/views/sertifikasi/JadwalTc/JadwalTcRplSesiTiga')
const JadwalTcUploadAbsensiSertifikasi = () => import('@/views/sertifikasi/JadwalTc/UploadAbsensiSertifikasi')
const JadwalTcUploadAbsensiRpl = () => import('@/views/sertifikasi/JadwalTc/UploadAbsensiRpl')
const PengajuanUjian = () => import('@/views/sertifikasi/PengajuanUjian/PengajuanUjian')
const PengajuanDasar = () => import('@/views/sertifikasi/PengajuanUjian/PengajuanDasar')
const PengejuanProfessional = () => import('@/views/sertifikasi/PengajuanUjian/PengajuanProfessional')
const PengajuanLanjutan = () => import('@/views/sertifikasi/PengajuanUjian/PengajuanLanjutan')

/**
 * RPL
 */
const MasterRpl = () => import('@/views/rpl/MasterRpl/MasterRpl')
const MasterRplTambah = () => import('@/views/rpl/MasterRpl/MasterRplTambah')
const MasterRplEdit = () => import('@/views/rpl/MasterRpl/MasterRplEdit')
const DataPesertaRpl = () => import('@/views/rpl/DataPeserta/DataPesertaRpl')
const DetailDataPesertaRpl = () => import('@/views/rpl/DataPeserta/DetailDataPeserta')
const DataPesertaDokumenRpl = () => import('@/views/rpl/DataPeserta/DataPesertaDokumen.vue')
const RiwayatPesertaRpl = () => import('@/views/rpl/RiwayatPeserta/RiwayatPesertaRpl')
const DetailRiwayatPesertaRpl = () => import('@/views/rpl/RiwayatPeserta/DetailRiwayatPesertaRpl')
const MasterRplInstrukturrpl = () => import('@/views/rpl/MasterInstrukturRpl/MasterRplInstrukturrpl')
const MasterRplInstrukturTambah = () => import('@/views/rpl/MasterInstrukturRpl/MasterRplInstrukturTambah')
const MasterRplInstrukturEdit = () => import('@/views/rpl/MasterInstrukturRpl/MasterRplInstrukturEdit')

const Tambah = () => import('@/views/sertifikasi/DataPeserta/DataPesertaRpl/DataPesertaRpl')
const MasterRplLainnya = () => import('@/views/sertifikasi/MasterRpl/MasterRplLainya/MasterRplLainya')
const MasterRplLainnyaTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplLainya/MasterRplLainyaTambah')

const MasterSertifikasiRpl = () => import('@/views/sertifikasi/MasterRpl/MasterSertifikasiRpl')
const DataPesertaRplWorkshop = () => import('@/views/sertifikasi/MasterRpl/MasterRplWorkshop/DataPesertaRplWorkshop')
const MasterRplCta = () => import('@/views/sertifikasi/MasterRpl/MasterRplCta/MasterRplCta')
const DataPesertaRplCta = () => import('@/views/sertifikasi/MasterRpl/MasterRplCta/DataPesertaRplCta')
const MasterRplCtaTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplCta/MasterRplCtaTambah')
const MasterRplCtaEdit = () => import('@/views/sertifikasi/MasterRpl/MasterRplCta/MasterRplCtaEdit')
const MasterRplRna = () => import('@/views/sertifikasi/MasterRpl/MasterRplRna/MasterRplRna')
const MasterRplRnaTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplRna/MasterRplRnaTambah')
const MasterRplRnaEdit = () => import('@/views/sertifikasi/MasterRpl/MasterRplRna/MasterRplRnaEdit')
const MasterRplPpak = () => import('@/views/sertifikasi/MasterRpl/MasterRplPpak/MasterRplPpak')
const MasterRplPpakTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplPpak/MasterRplPpakTambah')
const MasterRplPpakEdit = () => import('@/views/sertifikasi/MasterRpl/MasterRplPpak/MasterRplPpakEdit')
const MasterRplBpk = () => import('@/views/sertifikasi/MasterRpl/MasterRplBpk/MasterRplBpk')
const MasterRplBpkTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplBpk/MasterRplBpkTambah')
const MasterRplBpkEdit = () => import('@/views/sertifikasi/MasterRpl/MasterRplBpk/MasterRplBpkEdit')
const MasterRplCpai = () => import('@/views/sertifikasi/MasterRpl/MasterRplCpai/MasterRplCpai')
const MasterRplCpaiTambah = () => import('@/views/sertifikasi/MasterRpl/MasterRplCpai/MasterRplCpaiTambah')
const MasterRplCpaiEdit = () => import('@/views/sertifikasi/MasterRpl/MasterRplCpai/MasterRplCpaiEdit')

/**
 * Mata Uji
 */
const MasterMataUji = () => import('@/views/sertifikasi/MasterMataUji/MasterMataUji')

/**
 * Sertifikasi
 */
const MasterSertifikasi = () => import('@/views/sertifikasi/MasterSertifikasi/MasterSertifikasi')
const MasterSertifikasiTambah = () => import('@/views/sertifikasi/MasterSertifikasi/MasterSertifikasiTambah')
const MasterSertifikasiEdit = () => import('@/views/sertifikasi/MasterSertifikasi/MasterSertifikasiEdit')

// Keanggotaan
const LaporanIuran = () => import('@/views/keanggotaan/IuranAnggota/laporan-iuran')
const OutandingIuranKeanggotaan = () => import('@/views/keanggotaan/IuranAnggota/outstanding-iuran')
const PengaturanIuran = () => import('@/views/keanggotaan/IuranAnggota/pengaturan-iuran')
const MasterIuranAnggota = () => import('@/views/keanggotaan/IuranAnggota/MasterIuran')
const GenerateInvoice = () => import('@/views/keanggotaan/GenerateInvoice')
const Kap = () => import('@/views/keanggotaan/kap/Kap')
const RiwayatEditKap = () => import('@/views/keanggotaan/RiwayatEditKap/RiwayatEditKap')
// const DataAnggotaKap = () => import('@/views/keanggotaan/Kap')
const KapDataAnggota = () => import('@/views/keanggotaan/kap/DataAnggotaKap')
const KapTambah = () => import('@/views/keanggotaan/kap/KapTambah')
const KapEdit = () => import('@/views/keanggotaan/kap/KapEdit')
const PelaporanSkp = () => import('@/views/keanggotaan/PelaporanSKP/PelaporanSkp')
const PelaporanSkpDetail = () => import('@/views/keanggotaan/PelaporanSKP/PelaporanSkpDetail')
const PelaporanSkpTambah = () => import('@/views/keanggotaan/PelaporanSKP/PelaporanSkpTambah')
const PengajuanRekomendasi = () => import('@/views/keanggotaan/pengajuan-rekomendasi/PengajuanRekomendasi')
const PengajuanRekomendasiUnverified = () => import('@/views/keanggotaan/pengajuan-rekomendasi/PengajuanRekomendasiUnverified')
const PengajuanRekomendasiDokumen = () => import('@/views/keanggotaan/pengajuan-rekomendasi/PengajuanRekomendasiDokumen')
const AseanCpa = () => import('@/views/keanggotaan/AseanCpa')
const AseanCpaPengajuanRekomendasi = () => import('@/views/keanggotaan/AseanCpaPengajuanRekomendasi')
const KategoriAnggota = () => import('@/views/keanggotaan/kategori-anggota/KategoriAnggota')
const Keanggotaan = () => import('@/views/keanggotaan/DataAnggota/Keanggotaan')
const KeanggotaanUnverified = () => import('@/views/keanggotaan/DataAnggota/unverified')
const CalonAnggota = () => import('@/views/keanggotaan/DataAnggota/CalonAnggota')
const KeanggotaanDataDiri = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataAnggota/DataDiri')
const KeanggotaanAnggota = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataAnggota/DataAnggota')
const KeanggotaanDokumen = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataAnggota/DataDokumen')
const KeanggotaanDataPelatihan = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataPelatihan/DataPelatihan')
const KeanggotaanSanksi = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataAnggota/DataSanksi')
const KeanggotaanDataSanksi = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/Sanksi/DataSanksi')
const KeanggotaanDataSertifikasi = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataSertifikasi/DataSertifikasi')
const KeanggotaanDataRpl = () => import('@/views/keanggotaan/DataAnggota/DataPeserta/DataRpl/DataRpl')
const KeanggotaanStatistik = () => import('@/views/keanggotaan/DataAnggota/Statistik')
const AnggotaUmum = () => import('@/views/keanggotaan/AnggotaUmum/AnggotaUmum')
const SanksiAnggota = () => import('@/views/keanggotaan/Sanksi/sanksi')
const AnggotaUmumPengajuanRekomendasi = () => import('@/views/keanggotaan/AnggotaUmum/AnggotaUmumPengajuanRekomendasi')
const KartuAnggotaMadya = () => import('@/views/keanggotaan/DataAnggota/KartuAnggota/Madya/index')
const KartuAnggotaBiasa = () => import('@/views/keanggotaan/DataAnggota/KartuAnggota/Biasa/index')

//Pelatihan
const KodePelatihan = () => import('@/views/pelatihan/KodePelatihan/KodePelatihan')
const DataPesertaPelatihanParent = () => import('@/views/pelatihan/DataPeserta/DataPesertaParent')
// data-peserta-pelatihan
const DaftarPelatihan = () => import('@/views/pelatihan/DaftarPelatihan/DaftarPelatihan')
const PelatihanOnline = () => import('@/views/pelatihan/PelatihanOnline/PelatihanOnline')
const Webinar = () => import('@/views/pelatihan/Webinar/Webinar')
const WebinarEdit = () => import('@/views/pelatihan/Webinar/WebinarEdit')
const WebinarTambah = () => import('@/views/pelatihan/Webinar/WebinarTambah')
const SoalPostTest = () => import('@/views/pelatihan/SoalPostTest/SoalPostTest')
const HasilPostTest = () => import('@/views/pelatihan/HasilPostTest/HasilPostTest')
const PengaturanSertifikatWebinar = () => import('@/views/pelatihan/Webinar/SertifikatWebinar')
const PengaturanSertifikatOffline = () => import('@/views/pelatihan/Workshop/SertifikatWorkshop')

const DataPesertaPelatihanDokumenWebinar = () => import('@/views/pelatihan/DataPeserta/PelatihanWebinar/DataPesertaDokumen')
const DataPesertaPelatihanDokumenOffline = () => import('@/views/pelatihan/DataPeserta/PelatihanOffline/DataPesertaDokumen')
const DataPesertaSertifikat = () => import('@/views/pelatihan/DataPeserta/PelatihanWebinar/Sertifikat')
// SKP
const DataSkpPeserta = () => import('@/views/pelatihan/DataSkpPeserta/DataSkpPeserta')
const DataSkpPesertaTambah = () => import('@/views/pelatihan/DataSkpPeserta/DataSkpPesertaTambah')
const KehadiranSkpPeserta = () => import('@/views/pelatihan/DataSkpPeserta/KehadiranPeserta')

const KehadiranPeserta = () => import('@/views/pelatihan/DataPeserta/PelatihanOffline/KehadiranPeserta')
const SkpPeserta = () => import('@/views/pelatihan/DataPeserta/PelatihanOffline/SkpPeserta')

const DataPengajuanSkpParent = () => import('@/views/pelatihan/DataPengajuanSkp/DataSkpParent')
const DataSkpNonTerstruktur = () => import('@/views/pelatihan/DataPengajuanSkp/SkpNonTerstruktur')
const DataPengajuanSkp = () => import('@/views/pelatihan/DataPengajuanSkp/SkpTerstruktur')
const DataPengajuanSkpEdit = () => import('@/views/pelatihan/DataPengajuanSkp/DataPengajuanSkpEdit')
const PelaporanSKPPelatihan = () => import('@/views/pelatihan/PelaporanSKP/PelaporanSkp')
const PelaporanSKPPelatihanDetail = () => import('@/views/pelatihan/PelaporanSKP/PelaporanSkpDetail')
const DataPesertaPelatihan = () => import('@/views/pelatihan/DataPeserta/DataPeserta')
const DataPesertaPelatihanOnline = () => import('@/views/pelatihan/DataPeserta/PelatihanOnline/DataPesertaPelatihanOnline')
const DataPesertaPelatihanOffline = () => import('@/views/pelatihan/DataPeserta/PelatihanOffline/DataPesertaPelatihanOffline')
const DataPesertaPelatihanWebinar = () => import('@/views/pelatihan/DataPeserta/PelatihanWebinar/DataPesertaPelatihanWebinar')
const DataPesertaPelatihanDataDiri = () => import('@/views/pelatihan/DataPeserta/DataDiri')
const DataPesertaPelatihanDataAnggota = () => import('@/views/pelatihan/DataPeserta/DataAnggota')
const DataPesertaPelatihanDokumen = () => import('@/views/pelatihan/DataPeserta/DataDokumen')
const DataPesertaPertahun = () => import('@/views/pelatihan/DataPeserta/DataPesertaPertahun')
const ECertificate = () => import('@/views/pelatihan/ECertificate/ECertificate')
const TemplateECertificate = () => import('@/views/pelatihan/ECertificate/TemplateECertificate')
const Kuesioner = () => import('@/views/pelatihan/Kuesioner/Kuesioner')
const PaketKuesioner = () => import('@/views/pelatihan/Kuesioner/PaketKuesioner')
const PaketKuesionerTambah = () => import('@/views/pelatihan/Kuesioner/PaketKuesionerTambah')
const PaketKuesionerEdit = () => import('@/views/pelatihan/Kuesioner/PaketKuesionerEdit')
const SummaryKuesioner = () => import('@/views/pelatihan/Kuesioner/SummaryKuesioner')
const LaporanKuesioner = () => import('@/views/pelatihan/Kuesioner/LaporanKuesioner')
const Signature = () => import('@/views/pelatihan/Signature/Signature')
const WorkshopPenyelenggara = () => import('@/views/pelatihan/Workshop/Penyelenggara')
const WorkshopInstruktur = () => import('@/views/pelatihan/instruktur/Instruktur')
const WorkshopInstrukturTambah = () => import('@/views/pelatihan/instruktur/InstrukturTambah')
const WorkshopInstrukturEdit = () => import('@/views/pelatihan/instruktur/InstrukturEdit')
const WorkshopMitraPelatihan = () => import('@/views/pelatihan/Workshop/MitraPelatihan')
const WorkshopKatalog = () => import('@/views/pelatihan/Workshop/Katalog')
const Workshop = () => import('@/views/pelatihan/Workshop/Workshop')
const WorkshopTambah = () => import('@/views/pelatihan/Workshop/WorkshopTambah')
const WorkshopEdit = () => import('@/views/pelatihan/Workshop/WorkshopEdit')
const WorkshopAbsensiPeserta = () => import('@/views/pelatihan/Workshop/WorkshopAbsensiPeserta')


// Finance
const SalesOrder = () => import('@/views/finance/SalesOrder')
const SalesOrderTambah = () => import('@/views/finance/SalesOrderTambah')
const SalesOrderEdit = () => import('@/views/finance/SalesOrderEdit')
const RplPelatihan = () => import('@/views/finance/RplPelatihan')
const sertifikasiRpl = () => import('@/views/finance/pembayaran/sertifikasi-rpl/SertifikasiRpl')
const PaymentParent = () => import('@/views/finance/pembayaran/PembayaranParent')
const Payment = () => import('@/views/finance/pembayaran/sertifikasi-reguler/Payment')
const Paymentkeanggotaan = () => import('@/views/finance/pembayaran/keanggotaan/keanggotaan')
const PaymentOutstanding = () => import('@/views/finance/pembayaran/Outstanding/Outstanding-Iuran')
const PengajuanRefund = () => import('@/views/finance/pembayaran/pengajuan-refund/PengajuanRefund')
const PaymentPelatihan = () => import('@/views/finance/pembayaran/pelatihan/Pelatihan')
const permintaanPembatalan = () => import('@/views/finance/permintaan-pembatalan/permintaanPembatalan')
const permintaanPembatalanParent = () => import('@/views/finance/permintaan-pembatalan/PermintaanPembatalanParent')
const permintaanPembatalanRpl = () => import('@/views/finance/permintaan-pembatalan/sertifikasi-rpl/SertifikasiRpl')
const permintaanPembatalanReguler = () => import('@/views/finance/permintaan-pembatalan/sertifikasi-reguler/Payment')
const permintaanPembatalankeanggotaan = () => import('@/views/finance/permintaan-pembatalan/keanggotaan/keanggotaan')
const permintaanPembatalanPelatihan = () => import('@/views/finance/permintaan-pembatalan/pelatihan/Pelatihan')
const PaymentSertifikasi = () => import('@/views/finance/Sertifikasi')
const PaymentSertifikasiDokumen = () => import('@/views/finance/SertifikasiDokumen')
const PaymentPelatihanDetail = () => import('@/views/finance/DetailPelatihan')
const Ekwitansi = () => import('@/views/finance/ekwitansi/Ekwitansi')
const Invoice = () => import('@/views/finance/ekwitansi/Invoice')
const KuitansiIuran = () => import('@/views/finance/ekwitansi/KuitansiIuran')
const KuitansiPelatihan = () => import('@/views/finance/ekwitansi/KuitansiPelatihan')

// Broadcast
const Broadcast = () => import('@/views/broadcast/BroadcastEmail');
const BroadcastAplikasi = () => import('@/views/broadcast/BroadcastAplikasi');
const BroadcastWhatsapp = () => import('@/views/broadcast/BroadcastWhatsapp');

// Log Activity
const LogActivity = () => import('@/views/log-activity/LogActivity');
const LogKeanggotaan = () => import('@/views/log-activity/LogKeanggotaan');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const LupaPassword = () => import('@/views/pages/LupaPassword')
const BuatPasswordBaru = () => import('@/views/pages/BuatPasswordBaru')
const Verifikasi = () => import('@/views/pages/Verifikasi')
const Register = () => import('@/views/pages/Register')

const DataAnggotaWebView = () => import('@/views/pages/DataAnggotaParent')
const DataAp = () => import('@/views/pages/DataAp')
const DataKap = () => import('@/views/pages/DataKap')
const LocationTC = () => import('@/views/pages/locationTC')

const DataKartuAnggotaBiasa = () => import('@/views/pages/DataKartuAnggotaBiasa')
const DataKartuAnggotaMadya = () => import('@/views/pages/DataKartuAnggotaMadya')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes() {
  return [
    {
      path: '/',
      name: 'Beranda',
      redirect: '/dashboard',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Beranda',
          component: Dashboard
        },

        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'data-master',
          redirect: '/data-master/informasi-umum',
          name: 'Data Master',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'informasi-umum',
              name: 'Master Informasi Umum',
              component: InformasiUmum
            },
            {
              path: 'artikel',
              name: 'Master Artikel',
              component: Artikel
            },
            {
              path: 'artikel/tambah',
              name: 'Master Artikel',
              component: ArtikelTambah
            },
            {
              path: 'artikel/edit/:idArtikel',
              name: 'Master Artikel',
              component: ArtikelEdit
            },
            {
              path: 'divisi',
              name: 'Master Divisi',
              component: Divisi
            },
            {
              path: 'tingkatan',
              name: 'Master Level',
              component: Tingkatan
            },
            {
              path: 'dokumen',
              name: 'Master Dokumen',
              component: Dokumen
            },
            {
              path: 'pakta-integritas',
              name: 'Master Pakta Integritas',
              component: PaktaIntegritas
            },
            {
              path: 'master-mata-kuliah',
              name: 'Master Mata Kuliah',
              component: MataKuliah
            },
            
            {
              path: 'dokumen-anggota-umum',
              name: 'Master Dokumen Anggota Umum',
              component: DokumenAnggotaUmum
            },
            {
              path: 'dokumen-pendukung',
              name: 'Master Dokumen Pendukung',
              component: DokumenPendukung
            },
            {
              path: 'dokumen-rekomendasi',
              name: 'Master Dokumen Rekomendasi',
              component: DokumenRekomendasi
            },
            {
              path: 'dokumen-asean-cpa',
              name: 'Master Dokumen Asean CPA',
              component: DokumenAseanCpa
            },
            {
              path: 'data-test-center',
              name: 'Master Test Center',
              component: DataTestCenter
            },
            {
              path: 'jadwal-test-center',
              name: 'Jadwal Test Center',
              component: JadwalTc
            },
            {
              path: 'master-periode',
              name: 'Master periode',
              component: Periode
            },
            {
              path: 'master-periode-iuran',
              name: 'Periode Iuran',
              component: PeriodeIuran
            },
            {
              path: 'master-periode-rpl',
              name: 'Periode Rpl',
              component: PeriodeRpl
            },

            {
              path: 'data-test-center-tambah',
              name: 'Data Test Center / Tambah',
              component: DataTestCenterTambah
            },
            {
              path: 'data-test-center-edit/:id_tc',
              name: 'Data Test Center / Ubah',
              component: DataTestCenterEdit
            },
            {
              path: 'cabang',
              name: 'Master Cabang',
              component: Cabang
            },
            {
              path: 'kupon',
              name: 'Master Kupon',
              component: Kupon
            },
            {
              path: 'master-lokasi',
              name: 'Master Lokasi Provinsi',
              component: MasterLokasi
            },
            {
              path: 'master-lokasi-kota',
              name: 'Master Lokasi Kota/Kab',
              component: MasterLokasiKota
            },
            {
              path: 'master-lokasi-kecamatan',
              name: 'Master Lokasi Kecamatan',
              component: MasterLokasiKecamatan
            },
            {
              path: 'karir',
              name: 'Master Karir',
              component: Karir
            }
          ]
        },
        {
          path: 'user-manajemen',
          redirect: '/user-manajemen/petugas-iapi',
          name: 'Manajemen Pengguna',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'petugas-iapi',
              name: 'Petugas Back Office',
              component: PetugasIapi,
              redirect: '/user-manajemen/petugas-aktif',
            },
            {
              path: 'petugas-aktif',
              name: 'Petugas Back Office Aktif',
              component: PetugasIapiAktif
            },
            {
              path: 'petugas-tidak-aktif',
              name: 'Petugas Back Office Tidak Aktif',
              component: PetugasIapiTidakAktif
            },
            {
              path: 'petugas-lms-aktif',
              name: 'Petugas LMS Aktif',
              component: PetugasLMSAktif
            },
            {
              path: 'petugas-lms-tidak-aktif',
              name: 'Petugas LMS Tidak Aktif',
              component: PetugasLMSTidakAktif
            },
            {
              path: 'petugas-grader',
              name: 'Petugas Bank Soal Aktif',
              component: PetugasGrader
            },
            {
              path: 'petugas-grader-aktif',
              name: 'Petugas Bank Soal Aktif',
              component: PetugasBankSoalAktif
            },
            {
              path: 'petugas-grader-tidak-aktif',
              name: 'Petugas Bank Soal Tidak Aktif',
              component: PetugasBankSoalTidakAktif
            },
            {
              path: 'petugas-grader-tambah',
              name: 'Petugas Bank Soal',
              component: PetugasGraderTambah
            },
            {
              path: 'petugas-grader-edit/:id_user',
              name: 'Petugas Grader',
              component: PetugasGraderEdit
            },
            {
              path: 'petugas-iapi-tambah',
              name: 'Petugas IAPI / Tambah',
              component: PetugasIapiTambah
            },
            {
              path: 'petugas-iapi-edit/:id_user',
              name: 'Petugas IAPI / Edit',
              component: PetugasIapiEdit
            },
            {
              path: 'petugas-lms-tambah',
              name: 'Petugas LMS / Tambah',
              component: PetugasLMSTambah
            },
            {
              path: 'petugas-lms-edit/:id_user',
              name: 'Petugas LMS / Edit',
              component: PetugasLMSEdit
            },
            {
              path: 'petugas-tc',
              name: 'Petugas Test Center Aktif',
              component: PetugasTc
            },
            {
              path: 'petugas-tc-aktif',
              name: 'Petugas Test Center Aktif',
              component: PetugasTcAktif
            },
            {
              path: 'petugas-tc-tidak-aktif',
              name: 'Petugas Test Center Tidak Aktif',
              component: PetugasTcTidakAktif
            },
            {
              path: 'petugas-tc-tambah',
              name: 'Petugas Test Center / Tambah',
              component: PetugasTcTambah
            },
            {
              path: 'petugas-tc-edit/:id_user',
              name: 'Petugas Test Center / Edit',
              component: PetugasTcEdit
            },
            {
              path: 'user-grader',
              name: 'Grader Aktif',
              component: UserGrader
            },
            {
              path: 'user-grader-aktif',
              name: 'Grader Aktif',
              component: UserGraderAktif
            },
            {
              path: 'user-grader-tidak-aktif',
              name: 'Grader Tidak Aktif',
              component: UserGraderTidakAktif
            },
            {
              path: 'user-grader-tambah',
              name: 'Grader / Tambah',
              component: UserGraderTambah
            },
            {
              path: 'user-grader-edit/:id_user',
              name: 'Grader / Edit',
              component: UserGraderEdit
            },
          ]
        },
        {
          path: 'sertifikasi',
          redirect: '/sertifikasi/master-sertifikasi',
          name: 'Sertifikasi',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'master-sertifikasi',
              name: 'Master Sertifikasi',
              component: MasterSertifikasi
            },
            {
              path: 'master-mata-uji',
              name: 'Master Mata Uji',
              component: MasterMataUji
            },
            {
              path: 'master-sertifikasi/tambah',
              name: 'Master Sertifikasi / Tambah',
              component: MasterSertifikasiTambah
            },
            {
              path: 'master-sertifikasi/edit/:id_sertifikasi',
              name: 'Master Sertifikasi / Edit',
              component: MasterSertifikasiEdit
            },
            {
              path: 'data-peserta-sertifikasi/:id_sertifikasi_peserta',
              name: 'Data Peserta Sertifikasi',
              component: DataPesertaSertifikasi
            },
            {
              path: 'data-peserta',
              name: 'Data Peserta',
              component: DataPeserta,
            },
            
            {
              path: 'data-peserta/sertifikasi-rpl/detail-sertifikasi-rpl/:id_sertifikasi_rpl_peserta',
              name: 'Detail Data Peserta Sertifikasi RPL',
              component: DetailDataPesertaSertifikasiDokumenRpl
            },
            
            {
              path: 'master-waiver',
              name: 'Master Waiver',
              component: MasterWaiver,
              children: [
                {
                  path: 'penerima-waiver',
                  name: 'Penerima Waiver',
                  component: DataWeiver
                },
              ]
            },
            {
              path: 'riwayat-peserta',
              name: 'Riwayat Peserta',
              component: RiwayatPeserta,
            },
            {
              path: 'riwayat-peserta/detail-riwayat-sertifikasi/:id_user',
              name: 'Detail Riwayat Peserta Sertifikasi',
              component: DetailRiwayatPesertaSertifikasi,
              props: true
            },
            {
              path: 'pengajuan-sertifikat',
              name: 'Pengajuan Sertifikat',
              component: PengajuanSertifikat,
              
            },
            {
              path: 'pengajuan-sertifikat/data-dokumen/:id_pengajuan_penerbitan',
              name: 'Pengajuan Sertifikat',
              component: DokumenPengajuanSertifikat
            },
            {
              path: 'data-weiver-dokumen/:id_asean_cpa',
              name: 'Data Peserta Dokumen',
              component: WeiverDokumen

            },
            {
              path: 'data-peserta/calon-anggota',
              name: 'Data Peserta',
              component: DataPesertaCalonAnggota
            },
            {
              path: 'data-peserta-sertifikasi-rpl/:id_user',
              name: 'Data Peserta Sertifikasi / RPL',
              component: DataPesertaSertifikasiRpl
            },
            {
              path: 'data-peserta-sertifikasi/data-diri/:id_user',
              name: 'Data Peserta Sertifikasi / Data Diri',
              component: DataPesertaSertifikasiDatadiri
            },
            {
              path: 'data-peserta-sertifikasi/data-keanggotaan/:id_user',
              name: 'Data Peserta Sertifikasi / Data Keanggotaan',
              component: DataPesertaSertifikasiDatakeanggotaan
            },
            {
              path: 'data-peserta/data-dokumen/:id_sertifikasi_peserta',
              name: 'Data Peserta Sertifikasi / Data Dokumen',
              component: DataPesertaSertifikasiDokumen
            },
            {
              path: 'jadwal-tc-tambah',
              name: 'Tambah Jadwal Test Center',
              component: JadwalTcTambah
            },
            {
              path: 'jadwal-tc/sesi-1/:id_jadwal_tc',
              name: 'Jadwal Test Center / Sesi 1',
              component: JadwalTcSesiSatu
            },
            {
              path: 'jadwal-tc/sesi-2/:id_jadwal_tc',
              name: 'Jadwal Test Center / Sesi 2',
              component: JadwalTcSesiDua
            },
            {
              path: 'jadwal-tc/sesi-3/:id_jadwal_tc',
              name: 'Jadwal Test Center / Sesi 3',
              component: JadwalTcSesiTiga
            },
            {
              path: 'jadwal-tc/rpl-sesi-satu/:id_jadwal_tc',
              name: 'Jadwal Test Center / RPL Sesi 1',
              component: JadwalTcRplSesiSatu
            },
            {
              path: 'jadwal-tc/rpl-sesi-dua/:id_jadwal_tc',
              name: 'Jadwal Test Center / RPL Sesi 2',
              component: JadwalTcRplSesiDua
            },
            {
              path: 'jadwal-tc/rpl-sesi-tiga/:id_jadwal_tc',
              name: 'Jadwal Test Center / RPL Sesi 3',
              component: JadwalTcRplSesiTiga
            },
            {
              path: 'jadwal-tc/upload-absensi-sertifikasi',
              name: 'Jadwal Test Center / Upload Absensi Sertifikasi',
              component: JadwalTcUploadAbsensiSertifikasi
            },
            {
              path: 'jadwal-tc/upload-absensi-rpl',
              name: 'Jadwal Test Center / Upload Absensi RPL',
              component: JadwalTcUploadAbsensiRpl
            },

            {
              path: 'master-sertifikasi-rpl',
              name: 'Master Sertifikasi RPL',
              component: MasterSertifikasiRpl,
              children: [
                {
                  path: 'master-rpl-acpa',
                  name: 'Master RPL Workshop',
                  component: MasterRpl,
                },
                {
                  path: 'master-rpl-cta',
                  name: 'Master RPL Test Center',
                  component: MasterRplCta
                },
                {
                  path: 'master-rpl-rna',
                  name: 'Master RPL RNA',
                  component: MasterRplRna
                },
                {
                  path: 'master-rpl-ppak',
                  name: 'Master RPL PPAK',
                  component: MasterRplPpak
                },
                {
                  path: 'master-rpl-bpk',
                  name: 'Master RPL BPK',
                  component: MasterRplBpk
                },
                {
                  path: 'master-rpl-cpai',
                  name: 'Master RPL CPAI',
                  component: MasterRplCpai
                },
                {
                  path: 'master-rpl-lainnya',
                  name: 'Master RPL Lainnya',
                  component: MasterRplLainnya,
                },
                {
                  path: 'master-rpl-instrukturrpl',
                  name: 'Master RPL Instruktur RPL',
                  component: MasterRplInstrukturrpl
                },
              ]
            },
            {
              path: 'RplWorkshop/data-rpl-acpa/:id_sertifikasi_rpl',
              name: 'Peserta RPL',
              component: DataPesertaRplWorkshop
            },
            {
              path: 'master-rpl-cta/tambah',
              name: 'Master RPL CTA / Tambah ',
              component: MasterRplCtaTambah
            },
            {
              path: 'master-rpl-cta/edit/:id_sertifikasi_rpl',
              name: 'Master RPL CTA / Edit',
              component: MasterRplCtaEdit
            },
            {
              path: 'RplWorkshop/data-rpl-cta/:id_sertifikasi_rpl',
              name: 'Peserta RPL CTA',
              component: DataPesertaRplCta
            },
            {
              path: 'master-rpl-rna',
              name: 'Master RPL RNA',
              component: MasterRplRna
            },
            {
              path: 'master-rpl-rna/tambah',
              name: 'Master RPL RNA / Tambah',
              component: MasterRplRnaTambah
            },
            {
              path: 'master-rpl-rna/edit/:id_sertifikasi_rpl',
              name: 'Master RPL RNA / Edit',
              component: MasterRplRnaEdit
            },
            {
              path: 'master-rpl-ppak',
              name: 'Master RPL PPAK',
              component: MasterRplPpak
            },
            {
              path: 'master-rpl-ppak/tambah',
              name: 'Tambah Master RPL / PPAK',
              component: MasterRplPpakTambah
            },
            {
              path: 'master-rpl-ppak/edit/:id_sertifikasi_rpl',
              name: 'Edit Master RPL / PPAK',
              component: MasterRplPpakEdit
            },
            {
              path: 'master-rpl-bpk',
              name: 'Master RPL BPK',
              component: MasterRplBpk
            },
            {
              path: 'master-rpl-bpk/tambah',
              name: 'Tambah Master RPL / BPK',
              component: MasterRplBpkTambah
            },
            {
              path: 'master-rpl-bpk/edit/:id_sertifikasi_rpl',
              name: 'Edit Master RPL / BPK',
              component: MasterRplBpkEdit
            },
            {
              path: 'master-rpl-cpai',
              name: 'Master RPL CPAI',
              component: MasterRplCpai
            },
            {
              path: 'master-rpl-cpai/tambah',
              name: 'Tambah Master RPL / CPAI',
              component: MasterRplCpaiTambah
            },
            {
              path: 'master-rpl-lainnya/tambah',
              name: 'Tambah Master RPL Lainnya',
              component: MasterRplLainnyaTambah
            },
            {
              path: 'master-rpl-cpai/edit/:id_sertifikasi_rpl',
              name: 'Edit Master RPL / CPAI',
              component: MasterRplCpaiEdit
            },
            {
              path: 'pengajuan-ujian',
              name: 'Pengajuan Ujian Non Anggota',
              component: PengajuanUjian
            },
            {
              path: 'pengajuan-dasar',
              name: 'Pengajuan Ujian Dasar',
              component: PengajuanDasar
            },
            {
              path: 'pengajuan-professional',
              name: 'Pengajuan Ujian Professional',
              component: PengejuanProfessional
            },
            {
              path: 'pengajuan-Lanjutan',
              name: 'Pengajuan Ujian Lanjutan',
              component: PengajuanLanjutan
            }
          ]
        },
        {
          path: 'sertifikasi-new',
          redirect: '/sertifikasi-new/master-sertifikasi',
          name: 'Sertifikasi New',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'master-sertifikasi',
              name: 'Master Sertifikasi',
              component: MasterSertifikasiNew
            },
            {
              path: 'master-sertifikasi/tambah',
              name: 'Tambah Sertifikasi',
              component: MasterSertifikasiNewTambah
            },
            {
              path: 'master-sertifikasi/tambah-rpl',
              name: 'Tambah Sertifikasi RPL',
              component: MasterSertifikasiRPLNewTambah
            },
            {
              path: 'master-sertifikasi/:kode/edit',
              name: 'Edit',
              component: MasterSertifikasiNewEdit
            },
            {
              path: 'master-sertifikasi/:kode/rpl-edit',
              name: 'Edit',
              component: MasterSertifikasiRPLNewEdit
            },            
            {
              path: 'data-peserta',
              name: 'Data Peserta Sertifikasi',
              component: DataPesertaSertifikasiNew
            },
            {
              path: 'data-peserta-rpl',
              name: 'Data Peserta Sertifikasi RPL',
              component: DataPesertaSertifikasiRPL
            },
            {
              path: 'data-peserta/data-dokumen/:id_sertifikasi_peserta',
              name: 'Data Peserta Sertifikasi / Data Dokumen',
              component: DataPesertaSertifikasiDokumenNew
            },
            {
              path: 'data-peserta-sertifikasi-detail/:id_sertifikasi_peserta',
              name: 'Detail Data Peserta Sertifikasi',
              component: DataPesertaSertifikasiDetailNew
            },
            {
              path: 'data-peserta-level',
              name: 'Data Peserta Level',
              component: DataPesertaLevel
            }
          ]
        },

        {
          path: 'rpl',
          redirect: 'rpl/data-peserta',
          name: 'RPL',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'master-rpl',
              name: 'Master RPL',
              component: MasterRpl
            },
            {
              path: 'master-rpl/tambah',
              name: 'Master RPL / Tambah',
              component: MasterRplTambah
            },
            {
              path: 'master-rpl/edit/:id_sertifikasi_rpl',
              name: 'Master RPL / Edit',
              component: MasterRplEdit
            },
            {
              path: 'data-peserta',
              name: 'Data Peserta',
              component: DataPesertaRpl
            },
            {
              path: 'data-peserta/:id_sertifikasi_rpl_peserta',
              name: 'Data Peserta',
              component: DetailDataPesertaRpl
            },
            {
              path: 'data-peserta/data-dokumen/:id_sertifikasi_rpl_peserta',
              name: 'Data Dokumen Sertifikasi RPL',
              component: DataPesertaDokumenRpl
            }, 
            {
              path: 'riwayat-peserta',
              name: 'Riwayat Peserta',
              component: RiwayatPesertaRpl
            },
            {
              path: 'riwayat-peserta/detail-riwayat-rpl/:id_user',
              name: 'Detail Riwayat Peserta RPL',
              component: DetailRiwayatPesertaRpl
            },
            {
              path: 'instruktur-rpl',
              name: 'Instruktur RPL',
              component: MasterRplInstrukturrpl
            },
            {
              path: 'instruktur-rpl/tambah',
              name: 'Instruktur RPL Tambah',
              component: MasterRplInstrukturTambah
            },
            {
              path: 'instruktur-rpl/edit/:idInstrukturRpl',
              name: 'Instruktur RPL / Edit',
              component: MasterRplInstrukturEdit
            },
            {
              path: 'list-waiver',
              name: 'List Waiver',
              component: listWaiver
            },
            {
              path: 'list-waiver/penerima-waiver/:idWaiver',
              name: 'List Waiver / Penerima Waiver',
              component: DataWaiverRpl
            },
           
            {
              path: 'pengajuan-sertifikat-rpl',
              name: 'Pengajuan Sertifikat RPL',
              component: PengajuanSertifikatRpl,
            },
            {
              path: 'pengajuan-sertifikat-rpl/data-dokumen/:id_pengajuan_penerbitan',
              name: 'Pengajuan Sertifikat',
              component : DokumenPengajuanSertifikatRpl
            }
          ],
        },
        {
          path: 'keanggotaan',
          redirect: '/keanggotaan/kategori-anggota',
          name: 'Keanggotaan',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'data-anggota/kartu-anggota-madya/:id_user',
              name: 'Kartu Anggota',
              component: KartuAnggotaMadya
            },
            {
              path: 'data-anggota/kartu-anggota-biasa/:id_user',
              name: 'Kartu Anggota',
              component: KartuAnggotaBiasa
            },
            {
              path: 'anggota-umum',
              name: 'Pendaftaran Anggota Umum',
              component: AnggotaUmum
            },
            {
              path: 'sanksi-anggota',
              name: 'Sanksi Anggota',
              component: SanksiAnggota
            },
            {
              path: 'statistik',
              name: 'Statistik',
              component: KeanggotaanStatistik
            },
            {
              path: 'anggota-umum/pengajuan-rekomendasi/:id_anggota_umum',
              name: 'Pengajuan Rekomendasi',
              component: AnggotaUmumPengajuanRekomendasi
            },
            {
              path: 'pengaturan-iuran',
              name: 'Pengaturan Iuran Anggota',
              component: PengaturanIuran
            },
            {
              path: 'laporan-iuran',
              name: 'Laporan Iuran',
              component: LaporanIuran
            },
            {
              path: 'outstanding-iuran',
              name: 'Outstanding Iuran',
              component: OutandingIuranKeanggotaan
            },
            {
              path: 'iuran-anggota',
              name: 'Iuran Anggota',
              component: MasterIuranAnggota,
            },
            {
              path: 'invoice/generate-invoice/:id_pengaturan_iuran',
              name: 'Iuran Anggota',
              component: GenerateInvoice
            },
            {
              path: 'kap',
              name: 'Kantor Akuntan Publik',
              component: Kap
            },
            {
              path: 'kap/data-anggota/:id_kap',
              name: 'KAP Data Anggota',
              component: KapDataAnggota
            },
            {
              path: 'kap/riwayat-edit-kap/:id_kap',
              name: 'Riwayat Edit KAP',
              component: RiwayatEditKap
            },
            {
              path: 'kap/tambah',
              name: 'Kantor Akuntan Publik',
              component: KapTambah
            },
            {
              path: 'kap/edit/:id_kap',
              name: 'Kantor Akuntan Publik',
              component: KapEdit
            },
            {
              path: 'pelaporan-skp',
              name: 'Laporan Perolehan SKP',
              component: PelaporanSkp
            },
            {
              path: 'pelaporan-skp/detail',
              name: 'Laporan Perolehan SKP',
              component: PelaporanSkpDetail
            },
            {
              path: 'pelaporan-skp/tambah',
              name: 'Laporan Perolehan SKP',
              component: PelaporanSkpTambah
            },
            {
              path: 'pengajuan-rekomendasi',
              name: 'Pengajuan Rekomendasi',
              component: PengajuanRekomendasi
            },
            {
              path: 'pengajuan-rekomendasi/unverified',
              name: 'Pengajuan Rekomendasi',
              component: PengajuanRekomendasiUnverified
            },
            {
              path: 'pengajuan-rekomendasi/persyaratan-dokumen/:id_rekomendasi_peserta',
              name: 'Pengajuan Rekomendasi',
              component: PengajuanRekomendasiDokumen
            },
            {
              path: 'asean-cpa',
              name: 'Asean CPA',
              component: AseanCpa
            },
            {
              path: 'asean-cpa/pengajuan-rekomendasi/:id_asean_cpa',
              name: 'Pengajuan Rekomendasi',
              component: AseanCpaPengajuanRekomendasi
            },
            {
              path: 'kategori-anggota',
              name: 'Kategori Anggota',
              component: KategoriAnggota
            },
            {
              path: 'data-anggota',
              name: 'Data Anggota Terverifikasi',
              component: Keanggotaan
            },
            {
              path: 'data-anggota/unverified',
              name: 'Data Anggota Belum Terverifikasi',
              component: KeanggotaanUnverified
            },
            {
              path: 'calon-anggota',
              name: 'Data Anggota',
              component: CalonAnggota
            },
            {
              path: 'data-anggota/data-diri/:id_user',
              name: 'Data Anggota',
              component: KeanggotaanDataDiri
            },
            {
              path: 'data-anggota/data-anggota/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanAnggota
            },
            {
              path: 'data-anggota/data-dokumen/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanDokumen
            },
            {
              path: 'data-anggota/data-sertifikasi/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanDataSertifikasi
            },
            {
              path: 'data-anggota/data-rpl/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanDataRpl
            },
            {
              path: 'data-anggota/data-pelatihan/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanDataPelatihan
            },
            {
              path: 'data-anggota/data-sanksi/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanDataSanksi
            },
            {
              path: 'data-anggota/sanksi/:id_user',
              name: 'Keanggotaan',
              component: KeanggotaanSanksi
            },
            {
              path: 'data-anggota/statistik',
              name: 'Statistik',
              component: KeanggotaanStatistik
            },
          ]
        },
        {
          path: 'pelatihan',
          redirect: '/pelatihan/kode-pelatihan',
          name: 'Pelatihan',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'kode-pelatihan',
              name: 'Kode Pelatihan',
              component: KodePelatihan
            },
            {
              path: 'daftar-pelatihan',
              redirect: 'daftar-pelatihan/lms',
              name: 'Daftar Pelatihan',
              component: DaftarPelatihan,
              children: [
                {
                  path: 'offline',
                  name: 'Pelatihan Offline',
                  component: Workshop
                },
                {
                  path: 'lms',
                  name: 'Pelatihan LMS',
                  component: PelatihanOnline
                },
                {
                  path: 'webinar',
                  name: 'Pelatihan Webinar',
                  component: Webinar
                },                
              ]
            },
            {
              path: 'daftar-pelatihan/soal-post-test/:id_workshop_pelatihan',
              name: 'Daftar Soal Post Test / Soal Post Test',
              component: SoalPostTest
            },
            {
              path: 'daftar-pelatihan/hasil-post-test/:id_workshop_pelatihan',
              name: 'Daftar Soal Post Test / Hasil Post Test',
              component: HasilPostTest
            },
            {
              path: 'data-skp-peserta',
              name: 'Data SKP Peserta', 
              component: DataSkpPeserta
            },
            {
              path: 'data-skp-peserta/tambah',
              name: 'Data SKP Peserta / Tambah',
              component: DataSkpPesertaTambah
            },
            {
              path: 'data-skp-peserta/kehadiran-peserta/:id_pelatihan',
              name: 'Kehadiran SKP Peserta',
              component: KehadiranSkpPeserta
            },
            {
              path: 'data-peserta-pelatihan/offline/kehadiran-peserta',
              name: 'Kehadiran Peserta',
              component: KehadiranPeserta
            },
            {
              path: 'data-peserta-pelatihan/skp-peserta',
              name: 'SKP Peserta',
              component: SkpPeserta
            },
            {
              path: 'data-peserta-pelatihan',
              redirect: 'pelatihan/data-peserta-pelatihan/lms',
              name: 'Data Peserta',
              component: DataPesertaPelatihanParent,
              children: [
                {
                  path: 'offline',
                  name: 'Data Peserta Pelatihan Offline',
                  component: DataPesertaPelatihanOffline
                },
                {
                  path: 'lms',
                  name: 'Data Peserta Pelatihan LMS',
                  component: DataPesertaPelatihanOnline
                },
                {
                  path: 'webinar',
                  name: 'Data Peserta Pelatihan Webinar',
                  component: DataPesertaPelatihanWebinar
                },
              ]
            },
            
            {
              path: 'data-peserta-pelatihan/webinar/data-dokumen/:id_pelatihan_peserta',
              name: 'Data Peserta / Dokumen Peserta',
              component: DataPesertaPelatihanDokumenWebinar
            },
            {
              path: 'data-peserta-pelatihan/offline/data-dokumen/:id_pelatihan_peserta',
              name: 'Data Peserta / Dokumen Peserta',
              component: DataPesertaPelatihanDokumenOffline
            },
            {
              path: 'data-peserta-pelatihan/webinar/sertifikat',
              name: 'Data Peserta / Sertifikat',
              component: DataPesertaSertifikat
            },
            {
              path: 'daftar-kuesioner',
              name: 'Kuesioner Daftar Pertanyaan',
              component: Kuesioner
            },
            {
              path: 'paket-kuesioner',
              name: 'Kuesioner Paket Kuesioner',
              component: PaketKuesioner
            },
            {
              path: 'paket-kuesioner/tambah',
              name: 'Paket Kuesioner',
              component: PaketKuesionerTambah
            },
            {
              path: 'paket-kuesioner/edit/:id_kuesioner',
              name: 'Paket Kuesioner',
              component: PaketKuesionerEdit
            },
            {
              path: 'summary-kuesioner',
              name: 'Summary Kuesioner',
              component: SummaryKuesioner
            },
            {
              path: 'laporan-kuesioner',
              name: 'Laporan Kuesioner',
              component: LaporanKuesioner
            },
            {
              path: 'data-pengajuan-skp',
              redirect: 'pelatihan/data-pengajuan-skp/terstruktur',
              name: 'Data Pengajuan SKP Non Terstruktur',
              component: DataPengajuanSkpParent,
              children: [
                {
                  path: 'terstruktur',
                  name: 'Data Pengajuan SKP Terstruktur',
                  component: DataPengajuanSkp
                },
                {
                  path: 'non-terstruktur',
                  name: 'Data Pengajuan SKP Terstruktur',
                  component: DataSkpNonTerstruktur,
                }
              ]
            },
            {
              path: 'data-pengajuan-skp/edit',
              name: 'Data Pengajuan SKP',
              component: DataPengajuanSkpEdit
            },
            {
              path: 'pelaporan-skp',
              name: 'Laporan Perolehan SKP',
              component: PelaporanSKPPelatihan
            },
            {
              path: 'pelaporan-skp/detail',
              name: 'Laporan Perolehan SKP',
              component: PelaporanSKPPelatihanDetail
            },
            {
              path: 'data-peserta',
              name: 'Data Peserta',
              component: DataPesertaPelatihan
            },
            {
              path: 'data-diri',
              name: 'Data Peserta',
              component: DataPesertaPelatihanDataDiri
            },
            {
              path: 'data-anggota',
              name: 'Data Peserta',
              component: DataPesertaPelatihanDataAnggota
            },
            {
              path: 'data-dokumen',
              name: 'Data Peserta',
              component: DataPesertaPelatihanDokumen
            },
            {
              path: 'data-peserta-pertahun',
              name: 'Data Peserta',
              component: DataPesertaPertahun
            },
            {
              path: 'e-sertifikat',
              name: 'E-Sertifikat',
              component: ECertificate
            },
            {
              path: 'template-e-sertifikat',
              name: 'Template E-Sertifikat',
              component: TemplateECertificate
            },
            {
              path: 'tanda-tangan',
              name: 'Tanda Tangan',
              component: Signature
            },
            {
              path: 'workshop',
              name: 'Workshop',
              component: Workshop
            },
            
            {
              path: 'daftar-pelatihan/offline/tambah',
              name: 'Daftar Pelatihan Offline / Tambah',
              component: WorkshopTambah
            },
            {
              path: 'daftar-pelatihan/offline/edit/:id_workshop_pelatihan',
              name: 'Daftar Pelatihan Offline / Edit',
              component: WorkshopEdit
            },
            {
              path: 'daftar-pelatihan/webinar/tambah',
              name: 'Daftar Pelatihan / Webinar / Tambah',
              component: WebinarTambah
            },
            {
              path: 'daftar-pelatihan/webinar/edit/:id_workshop_pelatihan',
              name: 'Daftar Pelatihan / Webinar / Edit',
              component: WebinarEdit
            },
            {
              path: 'daftar-pelatihan/webinar/pengaturan-sertifikat/:id',
              name: 'Daftar Pelatihan / Webinar / Pengaturan Sertifikat',
              component: PengaturanSertifikatWebinar
            },
            {
              path: 'daftar-pelatihan/offline/pengaturan-sertifikat/:id',
              name: 'Daftar Pelatihan / Offline / Pengaturan Sertifikat',
              component: PengaturanSertifikatOffline
            },
            {
              path: 'workshop/absensi_peserta',
              name: 'Workshop',
              component: WorkshopAbsensiPeserta
            },
            {
              path: 'penyelenggara',
              name: 'Penyelenggara',
              component: WorkshopPenyelenggara
            },
            {
              path: 'instruktur',
              name: 'Instruktur',
              component: WorkshopInstruktur
            },
            {
              path: 'instruktur/tambah',
              name: 'Instruktur',
              component: WorkshopInstrukturTambah
            },
            {
              path: 'instruktur/edit/:idInstruktur',
              name: 'Instruktur',
              component: WorkshopInstrukturEdit
            },
            {
              path: 'mitra-pelatihan',
              name: 'Mitra Pelatihan',
              component: WorkshopMitraPelatihan
            },
            {
              path: 'katalog',
              name: 'Katalog',
              component: WorkshopKatalog
            },
          ]
        },
        {
          path: 'keuangan',
          redirect: '/keuangan/pembayaran',
          name: 'Keuangan',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'sales-order',
              name: 'Order Penjualan',
              component: SalesOrder
            },
            {
              path: 'sales-order/tambah',
              name: 'Order Penjualan',
              component: SalesOrderTambah
            },
            {
              path: 'sales-order/edit',
              name: 'Order Penjualan',
              component: SalesOrderEdit
            },
            {
              path: 'pembayaran',
              name: 'Pembayaran',
              redirect: '/keuangan/pembayaran/sertifikasi-reguler',
              component: {
                render(c) { return c('router-view') }
              },
              component: PaymentParent,
              children: [
                {
                  path: 'sertifikasi-reguler',
                  name: 'Sertifikasi Reguler',
                  component: Payment
                },
                {
                  path: 'sertifikasi-rpl',
                  name: 'Sertifikasi RPL',
                  component: sertifikasiRpl
                },
                {
                  path: 'pelatihan',
                  name: 'Pelatihan',
                  component: PaymentPelatihan,
                },
                {
                  path: 'iuran-keanggotaan',
                  name: 'Iuran Keanggotaan',
                  component: Paymentkeanggotaan,
                },
                {
                  path: 'outstanding',
                  name: 'Outstanding Iuran',
                  component: PaymentOutstanding
                },
                {
                  path: 'pengajuan-refund',
                  name: 'Pengajuan Refund',
                  component: PengajuanRefund
                },
              ]
            },
            {
              path: 'permintaan-pembatalan',
              name: 'Permintaan Pembatalan',
              component: permintaanPembatalan
            },
            // {
            //   path: 'permintaan-pembatalan',
            //   name: 'Permintaan Pembatalan',
            //   redirect: '/keuangan/permintaan-pembatalan/sertifikasi-reguler',
            //   component: {
            //     render(c) { return c('router-view') }
            //   },
            //   component: permintaanPembatalanParent,
            //   children: [                
            //     {
            //       path: 'sertifikasi-reguler',
            //       name: 'Sertifikasi Reguler',
            //       component: permintaanPembatalanReguler
            //     },
            //     {
            //       path: 'sertifikasi-rpl',
            //       name: 'Sertifikasi RPL',
            //       component: permintaanPembatalanRpl
            //     },
            //     {
            //       path: 'pelatihan',
            //       name: 'Pelatihan',
            //       component: permintaanPembatalanPelatihan,
            //     },
            //     {
            //       path: 'iuran-keanggotaan',
            //       name: 'Iuran Keanggotaan',
            //       component: permintaanPembatalankeanggotaan,
            //     }
            //   ]
            // },
            {
              path: 'RPL-Pelatihan',
              name: 'RPL Pelatihan',
              component: RplPelatihan
            },
            {
              path: 'sertifikasi',
              name: 'Pembayaran',
              component: PaymentSertifikasi
            },
            {
              path: 'sertifikasi/persyaratan-dokumen',
              name: 'Pembayaran',
              component: PaymentSertifikasiDokumen
            },
            {
              path: 'pelatihan/detail-pelatihan',
              name: 'Pembayaran',
              component: PaymentPelatihanDetail
            },
            {
              path: 'e-kuitansi',
              name: 'E-Kuitansi',
              component: Ekwitansi
            },
            {
              path: 'pembayaran/detail-invoice/:id_invoice',
              name: 'Detail Invoice',
              component: Invoice
            },
            {
              path: 'pembayaran/kuitansi-iuran/:id_invoice',
              name: 'Kuitansi Iuran Keanggotaan',
              component: KuitansiIuran
            },
            {
              path: 'pembayaran/kuitansi-pelatihan/:id_invoice',
              name: 'Kuitansi Pelatihan',
              component: KuitansiPelatihan
            },
          ]
        },
        {
          path: 'broadcast',
          redirect: '/broadcast-email',
          name: 'Pengumuman',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '/broadcast-email',
              name: 'Pengumuman Email',
              component: Broadcast
            },
            {
              path: '/broadcast-pesan-aplikasi',
              name: 'Pengumuman Pesan Aplikasi',
              component: BroadcastAplikasi
            },
            {
              path: '/broadcast-whatsapp',
              name: 'Pengumuman Whatsapp',
              component: BroadcastWhatsapp
            }
          ]
        },
        {
          path: '/log-activity',
          name: 'Catatan Aktivitas',
          component: LogActivity
        },
        {
          path: '/log-keanggotaan',
          name: 'Catatan Keanggotaan',
          component: LogKeanggotaan
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },

      ]
    },

    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'lupa-password',
          name: 'LupaPassword',
          component: LupaPassword
        },
        {
          path: 'password-baru/:email/:kode_otp',
          name: 'PasswordBaru',
          component: BuatPasswordBaru
        },
        {
          path: 'verifikasi/:email',
          name: 'Verifikasi',
          component: Verifikasi
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'lokasi-tc',
          name: 'Lokasi TC',
          component: LocationTC
        },
        {
          path: 'data-kartu-anggota/biasa/:noAnggota',
          name: 'Data Anggota Biasa',
          component: DataKartuAnggotaBiasa
        },
        {
          path: 'data-kartu-anggota/madya/:noAnggota',
          name: 'Data Anggota Madya',
          component: DataKartuAnggotaMadya
        },
        {
          path: 'data-anggota',
          name: 'DataAnggotaWebView',
          component: DataAnggotaWebView,
          children : [
            {
              path: 'akuntan-publik',
              name: 'Akuntan Publik',
              component: DataAp,
            },
            {
              path: 'kantor-akuntan-publik',
              name: 'Kantor Akuntan Publik',
              component: DataKap,
            },
          ],
        }
      ]
    },
  ]
}

// router.beforeEach((to, from, next) => {
//   const publicPages = ['/login', '/register', '/home'];
//   const authRequired = !publicPages.includes(to.path);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     next('/login');
//   } else {
//     next();
//   }
// });

